/* eslint-disable no-console */
// no console warning is disabled, as this function communicates with the user via console and we don't want to use default logger here
import fs from 'fs';
import { buildSessionLogMarkerPattern } from '../../sessions/session_log_marker';
import { getLogFilesOrExit, type LogFileInfo } from './last_log';
import { openInEditorOrPrint } from './editor';

/**
 * Finds log files whose content references the given session/workflow id
 * (see `session_log_marker.ts`). A session resumed across separate `duo`
 * invocations can span more than one log file, so this can return several
 * matches, newest first (matching `getLogFilesWithStats`' ordering).
 */
function findSessionLogFiles(sessionId: string): LogFileInfo[] {
  const filesWithStats = getLogFilesOrExit();
  const pattern = buildSessionLogMarkerPattern(sessionId);

  return filesWithStats.filter((file) => {
    try {
      return pattern.test(fs.readFileSync(file.path, 'utf8'));
    } catch {
      // Unreadable file (e.g. removed concurrently) — not a match.
      return false;
    }
  });
}

export const openOrListSessionLogFiles = (sessionId: string) => {
  const matches = findSessionLogFiles(sessionId);

  if (matches.length === 0) {
    console.error(`No log files found for session "${sessionId}".`);
    process.exit(1);
    return;
  }

  if (matches.length === 1) {
    openInEditorOrPrint(matches[0].path);
    return;
  }

  console.log(`Multiple log files reference session "${sessionId}":`);
  matches.forEach((file) => console.log(file.path));
};
